import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  IonLoading,
  IonRefresher,
  IonRefresherContent,
  useIonViewWillEnter,
  IonButton,
} from '@ionic/react';
import { useParams, useHistory } from 'react-router-dom';
import { PageLayout } from 'containers/layout';
import MenuItems from 'containers/order/MenuItemList';
import { AuthSelectors } from 'redux/AuthRedux';
import { AppSelectors } from 'redux/AppRedux';
import OrderActions, { OrderSelectors } from 'redux/OrderRedux';
import api_v2 from 'services/api_v2';

function MenuItemsPage() {
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();
  const token = useSelector(AuthSelectors.selectToken);
  const loading = useSelector(OrderSelectors.selectMenuItemsLoading);
  const venueId = params.locationId;
  const venueDetail = useSelector(AppSelectors.selectVenueDetailById(venueId));

  const handleLoadItems = async (e) => {
    const api = api_v2(token);

    try {
      const menuItemResult = await api.getMenuItems(venueId);
      dispatch(
        OrderActions.setMenuItems(
          venueId,
          menuItemResult.map((d) => ({
            ...d,
            name: d.custom_name || d.name,
          }))
        )
      );
    } catch (err) {
      console.log("load menu item error: ", err.message);
    }

    e.detail.complete();
  };

  const handleViewCart = () => {
    history.replace(`/locations/${venueId}/cart/review`, {
      direction: 'forward',
    });
  };

  useIonViewWillEnter(() => {
    dispatch(OrderActions.loadMenuItems(venueId));
  });

  return (
    <PageLayout
      title={venueDetail && venueDetail.name}
      back
      footer={
        <IonButton
          color="tertiary"
          expand="block"
          fill="solid"
          onClick={handleViewCart}
        >
          View Cart
        </IonButton>
      }
    >
      <IonLoading isOpen={loading} message="Loading..." />
      <IonRefresher slot="fixed" onIonRefresh={handleLoadItems}>
        <IonRefresherContent />
      </IonRefresher>
      <MenuItems venueId={venueId} prefix={`/locations/${venueId}/cart/add`} />
    </PageLayout>
  );
}

export default MenuItemsPage;
